import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Drawer, Table } from "antd";
import H3Text from "@Uilib/h3Text";
import H3Image from "@Uilib/h3Image";
import closeIcon from "@Images/icons/icon-close-blue.png";
import { toISTDate } from "@Apis/constants";
import PaymentOutgoingActions from "@Actions/paymentOutgoingActions";
import "./style.scss";
import UserActions from "@Actions/userActions";
import ViewPayment from "../../Common/ViewPayment";
import PurchaseFooter from "../../Common/PurchaseFooter";
import PRZText from "../../Common/UI/PRZText";

/**
 *
 */
class PendingPaymentRequests extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      selectedRowKeys: [],
      selectedRows: [],
      paymentOutgoingColumns: [
        {
          title: "",
          render: (record) => (
            <div
              // onClick={() => {
              //   this.setState({
              //     selectedPurchaseRequest: record,
              //     showPrModal: true,
              //   });
              // }}
            >
              <div
                className="mobile-list__card"
                // onClick={() => {
                //   this.setState({
                //     showViewPayout: true,
                //     selectedPayment: record,
                //     selectedRowKeys: [],
                //     selectedRows: [],
                //   });
                // }}
              >
                <div className="mobile-list__card_header">
                  <div className="mobile-list__card_header-left">
                    <PRZText
                      text={`#${
                        record?.payment_id || " - "
                      }`}
                      className="mobile-list__card_item-number"
                    />
                  </div> 
                </div>
                <div className="mobile-list__card_body">
                  <div className="mobile-list__card_body-left">
                    <PRZText
                      text={`Vendor: ${record?.tenant_seller_info?.seller_name}`}
                      className="mobile-list__card_item-details"
                    />
                    <PRZText
                      text={`Payment Date: ${toISTDate(record.payment_date).format("DD/MM/YYYY")}`}
                      className="mobile-list__card_item-details"
                    />
                    <PRZText
                      text={`Business Unit: ${record.tenant_info?.tenant_name}`}
                      className="mobile-list__card_item-details"
                    />
                    <PRZText
                      text={`Amount: ${this.props.MONEY(record?.amount || 0)}`}
                      className="mobile-list__card_item-details"
                    />
                  </div>
                </div>
              </div>
            </div>
          ),
          responsive: ["xs"],
        },
        {
          title: "DATE",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => (
            <div className="column-date">
              <H3Text text={toISTDate(record.payment_date).format("DD/MM/YYYY")}/>
            </div>
          ),
        },
        {
          title: "BUSINESS UNIT",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => (
            <div className="associated-entity">
              {record.tenant_info?.tenant_name}
            </div>
          ),
        },
        {
          title: "PAYMENT #",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => (
            <H3Text
              text={record?.payment_id || "-"}
            />
          ),
        },
        {
          title: "VENDOR",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => {
            const { history } = this.props;
            return (
              <div
                className="associated-entity"
                onClick={() =>
                  history.push(
                    `/vendors/view/${record?.tenant_seller_info?.seller_id}`
                  )
                }
              >
                <div className="vendor-code">
                  {record?.tenant_seller_info?.internal_slr_code || "-"}
                </div>
                {record?.tenant_seller_info?.seller_name || " - "}
              </div>
            );
          },
        },
        {
          title: "AMOUNT",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => (
            <div className="column-date">
              {this.props.MONEY(record?.amount || 0)}
            </div>
          ),
        },
        {
          title: "",
          responsive: ["sm", "md", "lg", "xxl"],
          key: "action",
          className: 'list__actions-column',
          render: (text, record) => (
            <div className="list__actions">
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  this.setState({
                    showViewPayout: true,
                    selectedPayment: record,
                    selectedRowKeys: [],
                    selectedRows: [],
                  });
                }}
              >
                View
              </div>
            </div>
          ),
        },
      ],
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions("map_payment_request", 10, state.currentPage, () => {});
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @param {*} selectedRowKeys
   * @param {*} selectedRows
   */
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  /**
   *
   * @param {*} data
   * @return
   */
  getPaymentApprovedDataWithKey = (data) => {
    if (data) {
      const tempData = [];
      const paymentApprovalData = data;
      for (let i = 0; i < paymentApprovalData.length; i++) {
        tempData.push({
          ...paymentApprovalData[i],
          key: paymentApprovalData?.[i]?.payment_id,
        });
      }
      return tempData;
    }
    return [];
  };

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      tableBorder,
      pendingActions,
      user,
      getPendingActionsLoading,
      getPendingActions,
      getPaymentsOutgoing,
      updatePaymentOutgoingWorkflowLoading,
    } = this.props;
    const {
      paymentOutgoingColumns,
      showViewPayout,
      selectedPayment,
      currentPage,
      selectedRowKeys,
      selectedRows,
    } = this.state;
    return (
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <Drawer
              open={showViewPayout}
              onClose={() => this.setState({ showViewPayout: false })}
              width="1050px"
              destroyOnClose
            >
              <div className="custom-drawer__header-wrapper">
                <div className="custom-drawer__header" style={{ width: "1000px" }}>
                  <H3Text
                    text={`Payment Request #${selectedPayment?.payment_id} from ${selectedPayment?.tenant_info?.tenant_name}`}
                    className="custom-drawer__title"
                  />
                  <H3Image
                    src={closeIcon}
                    className="custom-drawer__close-icon"
                    onClick={() =>
                      this.setState({
                        showViewPayout: false,
                        selectedPayment: null,
                      })
                    }
                  />
                </div>
              </div>
              <ViewPayment
                selectPaymentTenant={selectedPayment?.tenant_info?.tenant_id}
                selectedPaymentId={selectedPayment?.payment_id}
                isQuickView
                callback={() => {
                  this.setState({ showViewPayout: false });
                  getPendingActions(
                    "map_payment_request",
                    10,
                    currentPage,
                    () => {}
                  );
                  getPaymentsOutgoing(
                    currentPage,
                    10,
                    user?.tenant_info?.tenant_id,
                    "",
                    "PENDING",
                    "",
                    "ISSUED"
                  );
                }}
              />
            </Drawer>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${Number(pendingActions?.payment_request_approval_count)} Payment Requests Pending on Your Approval`}
                    </div>
                  </div>
                )}
                bordered={tableBorder}
                loading={
                  getPendingActionsLoading || updatePaymentOutgoingWorkflowLoading
                }
                showHeader
                size="small"
                scroll="scroll"
                columns={paymentOutgoingColumns}
                dataSource={this.getPaymentApprovedDataWithKey(
                  pendingActions?.payment_requests
                )}
                rowSelection={
                  window.screen.width > 425
                    ? {
                        selectedRowKeys,
                        onChange: this.onSelectChange,
                      }
                    : false
                }
                pagination={
                  Number(pendingActions?.payment_request_approval_count) > 10
                    ? {
                        defaultCurrent: 1,
                        total: Number(
                          pendingActions?.payment_request_approval_count
                        ),
                        pageSize: 10,
                        position: ["bottomRight"],
                        showSizeChanger: false,
                        onChange: (page) => {
                          getPendingActions(
                            "map_payment_request",
                            10,
                            page,
                            () => {}
                          );
                          this.setState({ currentPage: page });
                        },
                      }
                    : false
                }
              />
            </div>
            <PurchaseFooter
              selectedRowKeys={selectedRowKeys}
              selectedRows={selectedRows}
              callback={() => {
                getPendingActions("map_payment_request", 10, currentPage, () => {});
                this.setState({
                  selectedRows: [],
                  selectedRowKeys: [],
                });
              }}
              isApprovalPayments
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ UserReducers, PaymentOutgoingReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  approvedPayments: PaymentOutgoingReducers.approvedPayments,
  getApprovedOnlinePaymentsLoading:
    PaymentOutgoingReducers.getApprovedOnlinePaymentsLoading,
  updatePaymentOutgoingWorkflowLoading:
    PaymentOutgoingReducers.updatePaymentOutgoingWorkflowLoading,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
});

const mapDispatchToProps = (dispatch) => ({
  getApprovedOnlinePayments: (page, limit, tenantId, tenantRoleId) =>
    dispatch(
      PaymentOutgoingActions.getApprovedOnlinePayments(
        page,
        limit,
        tenantId,
        tenantRoleId
      )
    ),
  getPaymentsOutgoing: (
    page,
    limit,
    tenantId,
    tenantSellerId,
    status,
    tenantRoleId,
    approvedStatus
  ) =>
    dispatch(
      PaymentOutgoingActions.getPaymentsOutgoing(
        page,
        limit,
        tenantId,
        tenantSellerId,
        status,
        tenantRoleId,
        approvedStatus
      )
    ),
  getPendingActions: (actionType, limit, page, callback) =>
    dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
});

PendingPaymentRequests.propTypes = {
  user: PropTypes.any,
  tableBorder: PropTypes.bool,
  history: PropTypes.any,
  getPaymentsOutgoing: PropTypes.any,
  updatePaymentOutgoingWorkflowLoading: PropTypes.bool,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PendingPaymentRequests));
